import cx from 'classnames'

import {toCapitalCase} from '@s-ui/js/lib/string'

const COLOR_ICONS = {
  1: 'yellow',
  2: 'blue',
  3: 'beige',
  4: 'white',
  5: 'garnet',
  6: 'gray',
  7: 'brown',
  8: 'orange',
  9: 'black',
  10: 'red',
  11: 'pink',
  12: 'green',
  13: 'purple'
}

const BASE_CLASS = 'mt-FilterItemBasic'

export const getColorIconFromId = ({id}) => (
  <span
    className={cx(`${BASE_CLASS}-itemColorIcon`, `${BASE_CLASS}-itemColorIcon--color${toCapitalCase(COLOR_ICONS[id])}`)}
  />
)

export const getColorLabelSelected = ({colorsOptions, value}) => {
  const valueSet = new Set(value.map(String))

  return colorsOptions
    .filter(item => valueSet.has(item.id))
    .map(item => item.label)
    .join(', ')
}
